import React, { useState, useEffect } from "react"
import { post, put, remove } from "../../../utils/apiClient"
import toast from "react-hot-toast"
import Pagination from "../../common/pagination"
import { AlertTriangle, X, Plus } from "lucide-react"

const SubfolderManagement = ({
  practices,
  setSelectedPractice,
  selectedPractice,
  fetchPractices,
}) => {
  const [subfolders, setSubfolders] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [subfolderToEdit, setSubfolderToEdit] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [actionLoading, setActionLoading] = useState(false)
  const [subfolderIdToDelete, setSubfolderIdToDelete] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [hoveredRow, setHoveredRow] = useState(null)
  const [activeRow, setActiveRow] = useState(null)

  // useEffect(() => {
  //   loadSubfolder(true)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  useEffect(() => {
    // Set subfolder
    if (selectedPractice?.practiceId) {
      const practiceId = selectedPractice?.practiceId
      const onSelect = practices.find((d) => d.practiceId === practiceId)
      setSubfolders(
        onSelect?.subFolders?.map((sf) => {
          return {
            subfolderId: sf,
            subfolderName: sf,
          }
        }),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice, practices])

  const handleAddSubfolder = async (data) => {
    setActionLoading(true)

    const isEdit = !data.subFolders

    try {
      if (isEdit) {
        await put(`/practice/updateSubfolderToPractice`, data)
      } else {
        await post("/practice/addSubfoldersToPractice", data)
      }

      fetchPractices()
      setShowPopup(false)
      setSubfolderToEdit(null)
      toast.success(`Subfolder ${isEdit ? "updated" : "added"} successfully`)
    } catch (error) {
      console.error(`Failed to ${isEdit ? "update" : "add"} subfolder`, error)
      toast.error(error)
    } finally {
      setActionLoading(false)
    }
  }

  const handleDeleteSubfolder = async () => {
    setActionLoading(true)
    try {
      await remove(
        `/practice/${selectedPractice.practiceId}/subfolders/${subfolderIdToDelete.subfolderId}`,
      )
      fetchPractices()
      setSubfolderIdToDelete(null)
      toast.success("Subfolder removed successfully")
    } catch (error) {
      console.error("Failed to delete subfolder", error)
      toast.error("Something went wrong")
    } finally {
      setActionLoading(false)
    }
  }

  const handleAppChange = (event) => {
    const practiceId = event.target.value
    const onSelect = practices.find((app) => app.practiceId === practiceId)

    setSelectedPractice(onSelect)
    setSubfolders(
      onSelect.subFolders.map((sf) => {
        return {
          subfolderId: sf,
          subfolderName: sf,
        }
      }),
    )
  }

  // const pageSize = 10
  // const startIdx = (currentPage - 1) * pageSize
  // const currentSubfolders = subfolders?.slice(startIdx, startIdx + pageSize)

  const startIdx = (currentPage - 1) * rowsPerPage
  const currentSubfolders = subfolders.slice(startIdx, startIdx + rowsPerPage)
  const totalPages = Math.ceil(subfolders.length / rowsPerPage)

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      {/* {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : ( */}
      <div
        className="faxes-content"
        style={{ textAlign: "center", width: "100%", overflow: "hidden" }}
      >
        <div
          className="search-container"
          style={{
            width: "100%",
            alignItems: "end",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <div className="setting-note">
            <select
              className="select-dropdown"
              onChange={handleAppChange}
              value={selectedPractice.practiceId || ""}
            >
              {practices.map((practice) => (
                <option key={practice.practiceId} value={practice.practiceId}>
                  {practice.practiceName}
                </option>
              ))}
            </select>
          </div>
          {selectedPractice?.practiceId && (
            <button
              className="faxes-button"
              onClick={() => setShowPopup(true)}
              style={{ marginBottom: "5px" }}
            >
              Add Subfolder
            </button>
          )}
        </div>
        <div className="table-container">
          <table className="faxes-table">
            <thead>
              <tr>
                <th className="faxes-th" style={{ width: "80%" }}>
                  Subfolder Name
                </th>

                <th className="faxes-th" style={{ textAlign: "center" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {currentSubfolders?.length > 0 ? (
                currentSubfolders?.map((subfolder) => (
                  <tr
                    key={subfolder.subfolderId}
                    className={`fax-item${(hoveredRow === subfolder.subfolderId || activeRow === subfolder.subfolderId) ? " row-highlighted" : ""}`}
                    style={{ cursor: "unset" }}
                    onMouseEnter={() => {
                      setHoveredRow(subfolder.subfolderId)
                      if (activeRow !== subfolder.subfolderId) setActiveRow(null)
                    }}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td className="faxes-td">{subfolder.subfolderName}</td>

                    <td className="faxes-td" style={{ textAlign: "center" }}>
                      <button
                        className="faxes-button"
                        onClick={() => { setSubfolderToEdit(subfolder); setActiveRow(subfolder.subfolderId) }}
                      >
                        Edit
                      </button>
                      <button
                        className="faxes-button delete-button"
                        onClick={() => { setSubfolderIdToDelete(subfolder); setActiveRow(subfolder.subfolderId) }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="100%"
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #ccc",
                    }}
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {subfolders?.length > 0 && (
          <div
            className="faxes-pagination"
            style={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            {subfolders.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                onPageChange={(p) => setCurrentPage(p)}
                totalRows={subfolders.length}
                onRowsPerPageChange={(count) => {
                  setRowsPerPage(count)
                  setCurrentPage(1) // Reset to first page on change
                }}
              />
            )}
          </div>
        )}
      </div>
      {/* )} */}

      {(showPopup || subfolderToEdit) && (
        <SubfolderForm
          onSave={handleAddSubfolder}
          onClose={() => {
            setShowPopup(false)
            setSubfolderToEdit(null)
          }}
          subfolderToEdit={subfolderToEdit}
          actionLoading={actionLoading}
          selectedPractice={selectedPractice}
        />
      )}

      {subfolderIdToDelete && (
        <DeleteConfirmationPopup
          onConfirm={handleDeleteSubfolder}
          onCancel={() => setSubfolderIdToDelete(null)}
          actionLoading={actionLoading}
          subfolderIdToDelete={subfolderIdToDelete}
        />
      )}
    </div>
  )
}

const SubfolderForm = ({
  onClose,
  onSave,
  subfolderToEdit,
  actionLoading,
  selectedPractice,
}) => {
  const [subfolderNames, setSubfolderNames] = useState([""])
  const [errorMessage, setErrorMessage] = useState("")

  // Load initial data if editing
  useEffect(() => {
    if (subfolderToEdit?.subfolderName) {
      setSubfolderNames([subfolderToEdit.subfolderName])
    }
  }, [subfolderToEdit])

  const handleChange = (index, value) => {
    const newNames = [...subfolderNames]
    newNames[index] = value
    setSubfolderNames(newNames)
    setErrorMessage("")
  }

  const addMoreFields = () => {
    setSubfolderNames([...subfolderNames, ""])
  }

  const removeField = (index) => {
    const newNames = [...subfolderNames]
    newNames.splice(index, 1)
    setSubfolderNames(newNames)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const specialCharRegex = /[^a-zA-Z0-9 _-]/

    const trimmed = subfolderNames.map((name) => name.trim()).filter(Boolean)

    if (trimmed.length === 0) {
      if (subfolderToEdit) {
        setErrorMessage("Subfolder is required")
      } else {
        setErrorMessage("At least one subfolder is required.")
      }
      return
    }

    const hasInvalid = trimmed.some((name) => specialCharRegex.test(name))
    if (hasInvalid) {
      setErrorMessage(
        "Subfolder Name must not contain special characters. Allow '_' and '-' only",
      )
      return
    }

    if (subfolderToEdit) {
      if (trimmed[0].toLowerCase() === "trash") {
        setErrorMessage(
          "`Trash` subfolder cannot be created, Please use alternative name",
        )
        return
      }

      // Edit mode
      onSave({
        practiceId: selectedPractice.practiceId,
        subfolderOldName: subfolderToEdit.subfolderName,
        subfolderNewName: trimmed[0],
      })
    } else {
      if (trimmed.map((s) => s.toLowerCase().trim()).includes("trash")) {
        setErrorMessage(
          "`Trash` subfolder cannot be created, Please use alternative name",
        )
        return
      }

      // Add mode
      onSave({
        practiceId: selectedPractice.practiceId,
        subFolders: trimmed,
      })
    }
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">
            {`${subfolderToEdit ? `Update ` : "Add "}`}
            subfolder{" "}
            {`${
              subfolderToEdit
                ? `${subfolderToEdit.subfolderName}`
                : `to ${selectedPractice.practiceName}`
            }`}
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
        <form className="popup-group" onSubmit={handleSubmit}>
          <div className="form-group">
            {subfolderNames.map((name, idx) => (
              <div key={idx} style={{ display: "flex", marginBottom: 8 }}>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => handleChange(idx, e.target.value)}
                  style={{ flex: 1 }}
                />
                {!subfolderToEdit && subfolderNames.length > 1 && (
                  <span
                    type="button"
                    onClick={() => removeField(idx)}
                    style={{ marginLeft: 8, marginTop: 8, cursor: "pointer" }}
                  >
                    <X size={16} color="#dc2626" />
                  </span>
                )}
              </div>
            ))}

            {!subfolderToEdit && (
              <span
                type="button"
                onClick={addMoreFields}
                style={{ marginTop: 8, cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
              >
                <Plus size={16} color="#16a34a" /> Add More
              </span>
            )}
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="popup-buttons" style={{ marginTop: "50px" }}>
            <button
              className="popup-button cancel"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="popup-button save" type="submit">
              {actionLoading
                ? "Saving ..."
                : subfolderToEdit
                  ? `Update`
                  : `Save`}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const DeleteConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  subfolderIdToDelete,
}) => (
  <div className="popup-overlay">
    <div className="popup" style={{ padding: "20px", maxWidth: "700px" }}>
      {actionLoading ? (
        <div>Processing...</div>
      ) : (
        <>
          <p>
            Are you sure you want to delete the subfolder{" "}
            <strong>{subfolderIdToDelete?.subfolderName}?</strong>
          </p>
          <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <AlertTriangle size={18} color="#d97706" />
            This will detach the subfolder from all associated users and
            delete all related copied faxes. This action is irreversible.
          </p>
          <div className="popup-buttons">
            <button className="cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="delete" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)

export default SubfolderManagement
